<template>
    <CardPage :section="13" :page="9" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Nice job getting this done! Determining if a relationship is healthy or not can be hard. You’ll have another chance to think about healthy
            relationships in an upcoming activity. Just remember that you deserve to have your needs and desires met, both physically and emotionally.
            <span class="font-weight-bold">Try taking this quiz: </span>
            <a href="https://www.loveisrespect.org/wp-content/uploads/2017/07/HR-Quiz-final.pdf" target="_blank"
                >www.loveisrespect.org/wp-content/uploads/2017/07/HR-Quiz-final.pdf</a
            >
        </p>
        <p>You’ve earned another sticker for completing this activity!</p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section13/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section13/complete', true);
            this.$store.set('section13/sticker@earned', true);
        }
    }
};
</script>
